import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchStockReceiptDetail(id) {
  const { data: raw } = await request.get(`/ims/stock-receipt/${id}`);
  return parseVer4DetailResponse(raw);
}
